module.exports = {
      id: "listicle-usage",
      viewBox: "0 0 10.45 17.376",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#listicle",
      toString: function () {
        return this.url;
      }
    }